// const pack = $insertLanguagePack
// export const xmLanguage = typeof window !== 'undefined' ? pack : {}
export const pack = ''
export const xmLanguage = {}
